import React, { useState } from 'react';
import {
  DataInputContainerFacelift,
  RevisionOfProjectRowContainerFacelift,
  TitleProject
} from './styles';
import { RcFile } from 'antd/es/upload/interface';
import {
  IFabricationProject,
  IFabricationProjectsState
} from '../../../../../../store/ducks/fabrication-projects/types';
import { FabricationProjectsService } from '../../../../../../services/FabricationProjects';
import { Modal, Select, TextField } from '@gerdau/hefesto';
import { useDispatch } from 'react-redux';
import { sendTagging } from '../../../../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../../../../utils/Tagging';
import { addToast } from '../../../../../../store/ducks/toast/actions';
import { EToastTypes } from '../../../../../../store/ducks/toast/types';

interface RevisionOfProjectProps {
  uploadedFile: RcFile;
  projectState: IFabricationProjectsState;
  revisionOfProjectId?: number;
  closeModal: () => void;
  onCancel: () => void;
}

const RevisionOfProject: React.FC<RevisionOfProjectProps> = ({
  projectState,
  uploadedFile,
  revisionOfProjectId,
  closeModal,
  onCancel
}) => {
  const [isLoading, setIsloading] = useState(false);

  const contractNumber = projectState.contractNumber;

  const [previousProjectId, setPreviousProjectId] = useState<
    number | undefined
  >(revisionOfProjectId);
  const [numberOfProjectRevision, setNumberOfProjectRevision] = useState('');

  const sendSelectedProject = () => {
    if (!contractNumber || !numberOfProjectRevision || !previousProjectId) {
      return;
    }
    setIsloading(true);
    const selectedProject = projectState.projects?.find(
      (p) => p.id === previousProjectId
    ) as IFabricationProject;
    FabricationProjectsService.uploadProject(
      contractNumber,
      selectedProject.structures.map((s) => s.name),
      numberOfProjectRevision,
      uploadedFile,
      selectedProject.pavements.map((pav) => Number(pav.id)),
      previousProjectId
    )
      .then(() => {
        dispatch(
          sendTagging({
            screenName: 'LG:MaquetesEProjetos:Maquetes:EnviarRevisaoProjeto',
            itemName: 'sucess:revisao_projeto_enviada_com_sucesso',
            event: 'success',
            itemDescription:
              'maquetesEProjetos_maquetes_enviarRevisaoProjeto_revisaoEnviadaComSucesso',
            nonInteraction: true,
            extraData: {
              nome_maquete: selectedProject.mockupName || '',
              id_maquete: `${contractNumber}_${
                selectedProject.mockupName || ''
              }`,
              estrutura_projeto: selectedProject.structures
                .map((s) => s.name)
                .join(','),
              arquivo_anterior: selectedProject.fileName,
              numero_revisao_anterior: selectedProject.revision || '',
              numero_revisao_atual: numberOfProjectRevision
            }
          })
        );
        setIsloading(false);
        closeModal();
      })
      .catch((err) => {
        setIsloading(false);
        if (err?.response?.data?.status === '400') {
          const messages: string[] =
            Object.values(err?.response?.data?.errors) || [];

          if (messages.length > 0) {
            dispatch(
              addToast({ message: messages[0], type: EToastTypes.DANGER })
            );
          }
        }
      });
  };

  const dispatch = useDispatch();

  const { screenName = '', itemDescription = '' } = getTaggingInformationScreen(
    'maquetes-e-projetos-enviar-revisao'
  );

  const optionsSelect = projectState.projects
    ? projectState.projects
        .filter((project) => !project.nextRevisionId)
        .map((project) => ({
          value: project.id.toString(),
          label: `${project.revision} - ${project.fileName}`
        }))
    : [];

  return (
    <>
      <Modal
        onClose={() => onCancel()}
        modalSize="lg"
        title={'Enviar revisão do projeto'}
        buttons={{
          left: {
            children: 'Cancelar',
            name: 'Cancelar',
            onClick: () => {
              dispatch(
                sendTagging({
                  screenName,
                  itemName: `button:cancelar`,
                  itemDescription: `${itemDescription}_cancelar`,
                  event: 'click'
                })
              );
              onCancel();
            },
            type: 'button',
            disabled: isLoading
          },
          right: {
            children: 'Atualizar revisão',
            name: 'Atualizar revisão',
            onClick: () => {
              dispatch(
                sendTagging({
                  screenName,
                  itemName: `button:atualizar_revisao`,
                  itemDescription: `${itemDescription}_atualizarRevisao`,
                  filterInfo: `#rv:[${previousProjectId}]#inra:[${numberOfProjectRevision}]`,
                  event: 'click'
                })
              );
              sendSelectedProject();
            },
            type: 'button',
            disabled: numberOfProjectRevision === '' || isLoading,
            loading: isLoading
          }
        }}
      >
        <RevisionOfProjectRowContainerFacelift>
          <TitleProject>
            Arquivo revisado:
            {uploadedFile.name}
          </TitleProject>
          <span>
            *As revisões anteriores desse projeto estarão disponíveis em Ver
            opções {'>'} Histórico na tabela.
          </span>

          <DataInputContainerFacelift>
            <Select
              label={
                revisionOfProjectId
                  ? 'Selecione a revisão anterior'
                  : 'Revisão anterior'
              }
              value={previousProjectId?.toString()}
              onSelect={(value) => setPreviousProjectId(Number(value))}
              name="select-revisao"
              placeholder="- Selecione o arquivo do projeto -"
              disabled={!!revisionOfProjectId || isLoading}
              options={optionsSelect}
            />
            <TextField
              label="Insira o número da revisão atual"
              name="input-revisao"
              placeholder="Insira o número da revisão atual"
              value={numberOfProjectRevision}
              disabled={isLoading}
              onChange={(e) => setNumberOfProjectRevision(e.target.value)}
            />
          </DataInputContainerFacelift>
        </RevisionOfProjectRowContainerFacelift>
      </Modal>
    </>
  );
};

export default RevisionOfProject;
